var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAdminsDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.615 5.779V3.717A.725.725 0 0 0 7.883 3a.725.725 0 0 0-.733.717V5.78a5.025 5.025 0 0 1 1.465 0zM27.955 18.03l-.9-2.398a.733.733 0 0 0-.735-.468l-1.211.077-.564-1.117a.735.735 0 0 0-.704-.398l-1.27.08-4-2.26c.452-1.985-.431-4.11-2.325-5.18a4.94 4.94 0 0 0-1.327-.514c.505.436.944.955 1.293 1.547a6.057 6.057 0 0 1 .807 3.83 6.11 6.11 0 0 1-.95 2.62l.394.668c.226-.143.442-.306.644-.487l9.158 5.176c.212.12.47.128.69.022l.637-.308a.711.711 0 0 0 .363-.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.175 20.667-1.088-.526.082-1.244a.715.715 0 0 0-.406-.689l-1.14-.552-2.31-3.916a4.705 4.705 0 0 0 .63-5.624 4.846 4.846 0 0 0-2.739-2.162 6.137 6.137 0 0 1 2.026 4.552c0 1.35-.434 2.633-1.256 3.712a6.316 6.316 0 0 1-1.1 1.123l5.189 8.8a.734.734 0 0 0 .587.357l.709.045a.73.73 0 0 0 .769-.594l.444-2.517a.713.713 0 0 0-.397-.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.766 10.506c0-2.397-1.802-4.381-4.15-4.727v2.097h.223c.394 0 .733.297.752.683a.724.724 0 0 1-.732.752H6.927c-.394 0-.734-.297-.752-.683a.724.724 0 0 1 .731-.752h.244V5.78C4.801 6.125 3 8.109 3 10.506c0 2.14 1.437 3.952 3.418 4.561v10.83c0 .24.122.464.326.597l.591.386c.312.203.73.143.97-.138l1.67-1.962a.705.705 0 0 0 .046-.857l-.673-.989.705-1.036a.705.705 0 0 0 0-.796l-.705-1.036v-4.999c1.98-.609 3.418-2.42 3.418-4.561z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAdminsDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-admins-default.7b93297ef4612d47e6ddbd6310676cd5.svg";